import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { PasswordField } from './PasswordField';
import { TPasswordInputProps } from './types';

interface ControlledPasswordFieldProps<T extends FieldValues>
  extends Omit<TPasswordInputProps, 'name'> {
  name: Path<T>;
  control: Control<T>;
}

export const ControlledPasswordField = <T extends FieldValues>({
  name,
  control,
  ...props
}: ControlledPasswordFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const { ref, ...restField } = field;

        return (
          <PasswordField
            {...restField}
            {...props}
            ref={ref}
            error={!!error}
            helperText={error?.message}
          />
        );
      }}
    />
  );
};
